// extracted by mini-css-extract-plugin
export default {"dialogBody":"DialogsManager_dialogBody_b35a0","dialogWrapper":"DialogsManager_dialogWrapper_aba40","dialog":"DialogsManager_dialog_eae7d","appear":"DialogsManager_appear_da470"};